export const ADMIN_MEMBERS = {
  supplierBadge: "member-supplier",
  supplierFilter: "member-supplier-filter",
  supplierDialog: "supplier-link-dialog",
  supplierSearchInput: "supplier-link-search-input",
  supplierSearchButton: "supplier-link-search-button",
  supplierResult: "supplier-link-result",
  supplierLinkButton: "supplier-link-button",
};
